import { motion } from "framer-motion";
import "./styles.scss";

export function InfoCard({ icon, title, value, subValue, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className="info-card"
    >
      <div className="info-card__icon">
        {icon}
      </div>
      <h4 className="info-card__title">
        {title}
      </h4>
      <p className="info-card__value">
        {value}
      </p>
      {subValue && (
        <p className="info-card__subvalue">
          {subValue}
        </p>
      )}
    </motion.div>
  );
}
